/**
 * The browser tab — the only surface left (board 25). Four titles, four
 * favicons, nothing else: no desktop notifications, no badge you cannot
 * dismiss, and the title never counts things you have already read.
 */
export type TabState = 'plain' | 'recording' | 'missed';

const svg = (body: string): string =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">${body}</svg>`,
  )}`;

const ICONS: Record<TabState, string> = {
  plain: svg(
    '<rect width="32" height="32" rx="8" fill="#0E5B4F"/><text x="16" y="22" text-anchor="middle" font-family="Plus Jakarta Sans, system-ui, sans-serif" font-weight="700" font-size="18" fill="#fff">P</text>',
  ),
  recording: svg(
    '<rect width="32" height="32" rx="8" fill="#B3271E"/><circle cx="16" cy="16" r="6" fill="#fff"/>',
  ),
  missed: svg(
    '<rect width="32" height="32" rx="8" fill="#9A6212"/><text x="16" y="23" text-anchor="middle" font-family="system-ui, sans-serif" font-weight="700" font-size="20" fill="#fff">!</text>',
  ),
};

let current: string | null = null;

/** Sets the title and the favicon together, and only when something changed. */
export function setTab(state: TabState, detail?: string): void {
  const title =
    state === 'recording'
      ? `Recording · ${detail ?? ''}`.trim()
      : state === 'missed'
        ? 'Ptitim — a meeting was missed'
        : 'Ptitim';
  const key = `${state}|${title}`;
  if (key === current) return;
  current = key;
  document.title = title;
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = 'image/svg+xml';
  link.href = ICONS[state];
}
